import { Car, Sofa, Gem, Sparkles, ArrowRight } from "lucide-react";

const services = [
  {
    icon: Car,
    title: "Esterno Nanotech",
    desc: "Lavaggio completo della carrozzeria con formula waterless: sporco sollevato, sigillatura e lucidatura in un'unica operazione.",
    features: ["Carrozzeria + cerchi", "Vetri e specchietti", "Sigillante protettivo"],
    tag: "Best seller",
  },
  {
    icon: Sofa,
    title: "Interno Profondo",
    desc: "Pulizia accurata degli interni: aspirazione, rifinitura cruscotto, igienizzazione superfici e trattamento pelle/tessuti.",
    features: ["Aspirazione totale", "Igienizzazione abitacolo", "Plastiche e pelle"],
    tag: null,
  },
  {
    icon: Sparkles,
    title: "Pacchetto Completo",
    desc: "La combinazione perfetta: esterno nanotech + interni profondi. La tua auto come nuova, dentro e fuori.",
    features: ["Esterno + Interno", "Odor treatment", "Finish brillante"],
    tag: "Consigliato",
  },
  {
    icon: Gem,
    title: "Detailing Premium",
    desc: "Servizio di alta gamma con decontaminazione, correzione leggera, trattamento sigillante e protezione a lunga durata.",
    features: ["Decontaminazione", "Sealant premium", "Finish brillante"],
    tag: null,
  },
];

export default function Services() {
  const scrollToForm = () => document.getElementById("preventivo")?.scrollIntoView({ behavior: "smooth" });

  return (
    <section id="servizi" data-testid="services-section" className="relative py-24 md:py-32">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="max-w-3xl mb-16">
          <div className="flex items-center gap-3 mb-6">
            <div className="w-12 h-px bg-nexa-blue" />
            <span className="overline">Servizi</span>
          </div>
          <div className="heading text-3xl md:text-5xl text-white leading-tight">
            Quattro formule. Un solo <span className="text-nexa-blue">standard premium.</span>
          </div>
          <p className="text-nexa-muted mt-6 text-base md:text-lg max-w-2xl">
            Ogni servizio è studiato per adattarsi al tuo veicolo e al tempo a tua disposizione. Scegli il pacchetto o personalizzalo.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-6">
          {services.map((s, i) => {
            const Icon = s.icon;
            return (
              <div
                key={i}
                data-testid={`service-card-${i}`}
                className="card-surface p-8 group relative"
              >
                {s.tag && (
                  <span className="absolute top-4 right-4 text-[10px] tracking-widest uppercase bg-nexa-blue text-black px-2 py-1 font-semibold">
                    {s.tag}
                  </span>
                )}
                <div className="w-14 h-14 flex items-center justify-center border border-white/10 bg-black/40 mb-6 group-hover:border-nexa-blue transition-colors">
                  <Icon size={24} className="text-nexa-blue" />
                </div>
                <div className="heading text-2xl text-white mb-3 uppercase tracking-wide">{s.title}</div>
                <p className="text-nexa-muted text-sm leading-relaxed mb-6">{s.desc}</p>
                <ul className="space-y-2 mb-6">
                  {s.features.map((f, j) => (
                    <li key={j} className="flex items-center gap-3 text-sm text-nexa-silver">
                      <span className="w-1 h-1 bg-nexa-blue" />
                      {f}
                    </li>
                  ))}
                </ul>
                <button
                  onClick={scrollToForm}
                  data-testid={`service-cta-${i}`}
                  className="inline-flex items-center gap-2 text-sm font-semibold text-nexa-blue group-hover:gap-3 transition-all uppercase tracking-wider"
                >
                  Preventivo <ArrowRight size={14} />
                </button>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
